import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import { get } from 'lodash'
import { adminDriverList } from './actions/admin_driver'
import { Separator } from 'components/layout/Separator'
import { Formik, Form, Field } from 'formik'
import * as Yup from 'yup'
import {showSuccess, showError} from 'actions/Error'
import { handleSubmitResult } from 'actions/form'
import AdminCommonFormLayout from '../layout/AdminCommonFormLayout'
import { FormikVehicleAutoCompleteDropdown } from 'admin/components/vehicles/form/VehicleAutoCompleteDropdown'
import { FormikInputField } from 'components/form/InputField'
import { AdminDriverForm, validationSchema} from './form/AdminDriverForm'

export default function AdminDriver() {
    const dispatch = useDispatch()
    const history = useHistory()
    const { driver_id } = useParams()
    const driver = useSelector(() => adminDriverList.getObject(driver_id))
    const initial_values = driver
    const is_loading = useSelector(() => adminDriverList.isLoading()) || (driver_id && !get(driver, "id"))
    const is_busy = useSelector(() => adminDriverList.getIsSavingObject())
    const title = `${get(driver, ["display_name"], 'New driver')}`

    useEffect(() => {
        dispatch(adminDriverList.ensureObjectLoaded(driver_id))
    },[])

    const onSave = (values, formik_funcs) => {
        const on_ok = function(json) {
            dispatch(adminDriverList.invalidateList())
            showSuccess("Saved", "Driver saved")

            if ( ! driver_id ) {
                history.push(`/admin/driver/${json.id}`)
            }
        }
        if ( driver_id ) {
            values.id = driver_id
            return dispatch(adminDriverList.saveObject(values)).then((res) => handleSubmitResult({res, formik_funcs, on_ok}))
        } else {
            return dispatch(adminDriverList.saveNewObject(values)).then((res) => handleSubmitResult({res, formik_funcs, on_ok}))
        }
    }

    const getCellValue = (header_key, item, index) => {
        switch( header_key ) {
            default:
                return undefined
        }
    }

    return (
        <AdminCommonFormLayout
            breadcrumbs={[
                {name: 'admin_home'},
                {name: 'drivers', label: 'Drivers', url: '/admin/drivers'},
                {name: 'driver', label: get(driver, ["display_name"], 'New driver'), url: `/admin/driver/${driver_id}`}
            ]}
            is_busy={is_busy}
            is_loading={is_loading}
            title={title}
            initial_values={initial_values}
            validationSchema={validationSchema}
            onSave={onSave}
        >
          {
              ({formik_props}) => <AdminDriverForm formik_props={formik_props} />
          }
        </AdminCommonFormLayout>
    )
}
